import { onBeforeUnmount, onMounted, ref, type Ref } from 'vue';

/*
 * 新版本检测。
 *
 * 试用期间反复出现同一种误报：问题明明修好了，用户开着几天前的标签页
 * 继续测，回帖说“还是没修复”。SPA 页内跳转永远不会重新拉 index.html，
 * nginx 的 no-cache 只救得了重新加载的人，救不了不关标签页的人。
 *
 * 做法：构建时把构建号打进 bundle（__APP_BUILD__），同时在 dist 根写一份
 * /version.json。前端每 5 分钟、以及窗口重新获得焦点时比对一次，
 * 不一致就亮横幅提示刷新。fetch 用 no-store，绕开一切缓存层。
 */
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

export function useVersionCheck(): { updateAvailable: Ref<boolean>; reload: () => void } {
  const updateAvailable = ref(false);
  let timer: ReturnType<typeof setInterval> | null = null;

  async function check(): Promise<void> {
    if (updateAvailable.value) return;
    try {
      const response = await fetch('/version.json', { cache: 'no-store' });
      if (!response.ok) return;   // 开发环境没有这个文件，静默跳过
      const payload = await response.json() as { build?: string };
      if (payload.build && payload.build !== __APP_BUILD__) {
        updateAvailable.value = true;
      }
    } catch {
      // 网络抖动不值得打扰用户，下个周期再试
    }
  }

  function onFocus(): void {
    void check();
  }

  onMounted(() => {
    timer = setInterval(() => void check(), CHECK_INTERVAL_MS);
    window.addEventListener('focus', onFocus);
    void check();
  });
  onBeforeUnmount(() => {
    if (timer) clearInterval(timer);
    window.removeEventListener('focus', onFocus);
  });

  return { updateAvailable, reload: () => window.location.reload() };
}
